import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  selectedAlertId: null,
  selectedAiAlert: null,
  selectedAlertType: null,
  allExceptAnomalyPayload: null,
};

const switchMap = {};

switchMap[types.SET_SELECTED_AI_ALERT] = (state, action) => update(state, {
  $merge:  {...action.payload},
});

switchMap[types.SET_ALL_EXCEPT_ANOMALY_PAYLOAD] = (state, action) => update(state, {
  $set:  { allExceptAnomalyPayload : action.payload},
});

switchMap[types.RESET_ALERT_STATE] = (state, action) => update(state, {
  $set:  initialState,
});


export default (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);
